import { render } from "./QOrganizationalArchitecture.vue?vue&type=template&id=5547903a&ts=true"
import script from "./QOrganizationalArchitecture.vue?vue&type=script&lang=ts"
export * from "./QOrganizationalArchitecture.vue?vue&type=script&lang=ts"

import "./QOrganizationalArchitecture.vue?vue&type=style&index=0&id=5547903a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__